import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo obtengo acceso?',
    a: 'Es un producto 100% digital. Tras el pago, recibes un correo automático con el acceso/descarga.'
  }, {
    q: '¿Hay cargo mensual?',
    a: 'NO. Pago único.'
  }, {
    q: '¿Sirve para principiantes?',
    a: 'Sí. Está explicado paso a paso, de forma simple.'
  }, {
    q: '¿De verdad no necesito horno ni baño María?',
    a: 'Tal cual: no hay horno ni baño María. El método se basa en el cuajado en frío. (Y para el caramelo, si lo haces, es rapidísimo).'
  }, {
    q: '¿Tengo soporte si me trabo?',
    a: 'Sí, tienes soporte por WhatsApp para dudas mientras lo aplicas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 px-4 bg-cream-dark border-t border-caramel/20" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-brown-dark mb-12" data-id="element-49">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-50">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden transition-all" data-id="element-51">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-52">
                <span className="font-heading font-bold text-lg text-brown-dark pr-4" data-id="element-53">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUpIcon className="w-5 h-5 text-caramel flex-shrink-0" data-id="element-54" /> : <ChevronDownIcon className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-55" />}
              </button>

              {openIndex === index && <div className="px-6 pb-5 text-gray-700 font-medium" data-id="element-56">
                  <div className="w-full h-px bg-gray-100 mb-4" data-id="element-57"></div>
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}